import styled from '@emotion/styled';
import qianyiSvg from './assets/qianyi.svg';
import jushuitanSvg from './assets/jushuitan.svg';
import { useTranslate } from '@tolgee/react';
import StatusButton from 'components/StatusButton';
import { Button, message, Modal } from 'antd';
import { unAuthERP } from './service';
import { stores2storeScopes } from 'views/BootGuide/views/AiModel/share';
import { storeIds2stores } from '@knowledge/knowledges/general/StoreGroup/share';
import { Store, StoreScopesPreview } from 'components/StoreScopes';
import { useMemo } from 'react';
import dayjs from 'dayjs';
import { useAuth } from './ERPModal';
import { Preview } from '@knowledge/Activity/share';
import { PreviewWrapper } from 'views/Assistant/Department/components/AssignReceptionConfColumn';
import { FormOutlined } from '@ant-design/icons';

function ERPCard({
  erp,
  storeMap,
  onEdit,
  onUpdate,
}: {
  erp: ERP.ERP;
  storeMap: Record<number, Store>;
  onEdit: (mode?: 'store') => void;
  onUpdate: () => Promise<any>;
}) {
  const { t } = useTranslate();

  const { auth } = useAuth();

  const { id, name, storeIds, itemQueryType, reissueItemQueryType } = erp;

  const storeScopes = useMemo(
    () => stores2storeScopes(storeIds2stores(storeIds, storeMap)),
    [storeIds, storeMap],
  );

  const stores = (
    <div>
      {t('绑定店铺')}：{t('x家', { count: storeIds.length })}
      <Preview
        content={
          <PreviewWrapper>
            <StoreScopesPreview
              value={storeScopes}
              showSearch={false}
              showTitle={false}
              storeMap={storeMap}
            />
          </PreviewWrapper>
        }
      />
      <Button type="text" icon={<FormOutlined />} onClick={() => onEdit('store')} />
    </div>
  );

  const unAuth = () => {
    return new Promise<void>((resolve, reject) => {
      Modal.confirm({
        title: t('确认要解绑吗？'),
        content: t('erp-unauth-tips'),
        onOk: () => {
          return unAuthERP(id)
            .then(() => {
              message.success(t('已解绑'));
              return onUpdate();
            })
            .then(() => {
              resolve();
            })
            .catch(() => {
              reject();
              message.error(t('translation.操作失败，请稍后再试'));
            });
        },
        onCancel: () => resolve(),
      });
    });
  };

  if (erp.erpType === 'QIANYI') {
    return (
      <Container>
        <img src={qianyiSvg} alt="qianyi" />
        <section>
          <p>{name}</p>
          {stores}
        </section>
        <div>
          <StatusButton type="link" onClick={unAuth}>
            {t('解绑')}
          </StatusButton>
          <Button type="link" onClick={() => onEdit()}>
            {t('marketing.编辑')}
          </Button>
        </div>
      </Container>
    );
  }

  if (erp.erpType === 'JUSHUITAN') {
    const { erpType, expireTimeStamp, openLogisticsApi } = erp;
    return (
      <Container>
        <img src={jushuitanSvg} alt="jushuitan" />
        <section>
          <p>{name}</p>
          <span>
            {t('marketing.有效期')}：{dayjs(Number(expireTimeStamp)).format('YYYY-MM-DD')}
          </span>
          {stores}
        </section>
        <div>
          <StatusButton type="link" onClick={unAuth}>
            {t('解绑')}
          </StatusButton>
          <StatusButton
            type="link"
            onClick={() => {
              return auth({
                id,
                erpType,
                openLogisticsApi,
                itemQueryType,
                reissueItemQueryType,
                storeIds,
              }).catch(() => {
                message.error(t('phrase.获取数据失败，请稍后再试'));
              });
            }}
          >
            {t('ViewShops.request.action.of.Authorization')}
          </StatusButton>
          <Button type="link" onClick={() => onEdit()}>
            {t('marketing.编辑')}
          </Button>
        </div>
      </Container>
    );
  }

  return <></>;
}

const Container = styled.div`
  display: inline-flex;
  align-items: flex-start;
  min-width: 380px;
  min-height: 100%;
  padding: 12px;
  background: var(--fett-erp-card-bg);
  border: 2px;
  > img {
    flex: 0 0 auto;
    width: 56px;
    height: 56px;
    margin-right: 12px;
    background: var(--fett-bg-panel);
  }
  > section {
    flex: 1 0 0;
    > p {
      margin-bottom: 0;
      font-weight: bold;
    }
    > span {
      display: block;
      margin-top: 6px;
    }
  }
  > div {
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
  }
`;

export default ERPCard;
